import { TableColumn } from "@shared/components/table-implementation/types/column/header.type";
import { Observable, ReplaySubject } from "rxjs";

export class TableColumnMenuService {
  private _header: TableColumn | undefined = undefined;

  private _header$: ReplaySubject<TableColumn> = new ReplaySubject<TableColumn>(1);

  public header$: Observable<TableColumn> = this._header$.asObservable();

  public provideHeader (header: TableColumn): void {
    this._header = header;
    this._header$.next(header);
  }
}
